module.exports = __webpack_public_path__ + "static/media/Goodnest_android_1.eb5dcd21.jpg";